import '.gd{height:2rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.dx{justify-content:flex-end;}.ssr-plugin'
import '.cf{position:relative;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.b8{cursor:pointer;}.ssr-plugin'
import '.a8{width:100%;}.ssr-plugin'
import '.cp{position:sticky;}.ssr-plugin'
import '.ch{top:0;}.ssr-plugin'
import '.ge{z-index:8;}.ssr-plugin'
import '.cn{background:var(--shades-white);}.ssr-plugin'
import '.c1{padding:1rem;}.ssr-plugin'
import '.a9{justify-content:space-between;}.ssr-plugin'
import { useCallback, useState } from 'react'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Button } from '@app/components/core/button/Button'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { MegaMenu } from '../../megaMenu/MegaMenu.mobile'
import { faBars } from '@fortawesome/pro-regular-svg-icons'
import { useAuthModal } from '@app/util/hooks/useAuthModal'
import { pages } from '@app/util/links'
import { TextLink } from '@app/components/core/link/TextLink'
import { ProfileMenu } from '../blocks/ProfileMenu'
import { Image } from '@app/components/core/image/Image'
import { useTranslations } from '@i18n/useLanguage'

export type TopNavBarProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
}

const ACCOUNT_SLOT_WIDTH = '6rem'
const ACCOUNT_APPEAR_ANIMATION = 'nav-account-appear 220ms ease-out'

export const TopNavBar = ({
  userName,
  avatar,
  isLoading,
}: TopNavBarProps) => {
  const [navigationMenuOpen, setNavigationMenuOpen] = useState(false)
  const { showAuthModal } = useAuthModal()
  const translations = useTranslations().app.common
  const renderAccountSection = useCallback(() => {
    if (isLoading) {
      return (
        <div className="gd"
          style={{
            width: ACCOUNT_SLOT_WIDTH,}}
        />
      )
    }

    return userName ? (
      <div className="a dx"
        style={{
          width: ACCOUNT_SLOT_WIDTH,
          animation: ACCOUNT_APPEAR_ANIMATION,
        }}
      >
        <ProfileMenu>
          <div className="cf a b c b8"
          >
            <Avatar size="extra-small" labelSource={userName} image={avatar} />
          </div>
        </ProfileMenu>
      </div>
    ) : (
      <div className="a dx"
        style={{
          width: ACCOUNT_SLOT_WIDTH,
          animation: ACCOUNT_APPEAR_ANIMATION,
        }}
      >
        <Button
          variant="primary"
          label={translations.signUp}
          size="small"
          onClick={() => showAuthModal('signUp')}
        />
      </div>
    )
  }, [isLoading, userName, avatar, showAuthModal, translations.signUp])

  return (
    <div className="a8 cp ch ge cn"
    >
      <nav className="cn a8 a c1 a9 c"
      >
        <Button
          variant="link"
          icon={faBars}
          onClick={() => setNavigationMenuOpen(true)}
        />
        <TextLink to={pages.home} noHover={true} isBold={false} hasIcon={false}>
          <Image
            src={fullLogo}
            alt="Crowdbuilding Logo"
            resizeWidth={123}
            style={{
              width: 123,
            }}
          />
        </TextLink>
        {renderAccountSection()}
      </nav>
      <MegaMenu
        onClose={() => setNavigationMenuOpen(false)}
        isAuthenticated={userName !== undefined}
        isOpen={navigationMenuOpen}
      />
    </div>
  )
}
